import React from 'react';

export interface MarqueeBox {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
}

interface MarqueeSelectionProps {
  marquee: MarqueeBox | null;
}

const MarqueeSelection: React.FC<MarqueeSelectionProps> = ({ marquee }) => {
  if (!marquee) return null;

  const left = Math.min(marquee.x1, marquee.x2);
  const top = Math.min(marquee.y1, marquee.y2);
  const width = Math.abs(marquee.x2 - marquee.x1);
  const height = Math.abs(marquee.y2 - marquee.y1);

  return (
    <div
      className="absolute border-2 border-indigo-500 bg-indigo-500/10 z-50 pointer-events-none rounded-sm"
      style={{
        left: `${left}px`,
        top: `${top}px`,
        width: `${width}px`,
        height: `${height}px`,
      }}
    />
  );
};

export default MarqueeSelection;
